export default "__VITE_ASSET__e440e885__"